import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../utils';
import { get, isEmpty } from 'lodash';
import Button from './Button';
import Modal from './Modal';

const ErrorKioskModal = ({ confirmModalOpen, setConfirmModalOpen, kioskState }) =>{
  const { t, i18n } = useTranslation();
  const [ modalTimeout, setModalTimeout ] = useState(null);

  useEffect(() => {
    if (confirmModalOpen) {
      const timeoutId = setTimeout(() => {
        setConfirmModalOpen(false);
      }, 15000);

      setModalTimeout(timeoutId);
    } else {
      clearTimeout(modalTimeout);
    }

    return () => {
      clearTimeout(modalTimeout);
    };
  }, [ confirmModalOpen ]);


  const getConnectionErrorMessage = () => {
    const defaultMessage = t('error.connectionProblem');
    const latestConnection = kioskState?.kiosk?.latestConnection;
    let latestConnectionMessage;
    if (latestConnection) {
      latestConnectionMessage = t(
        'error.latestSuccessfulConnection',
        { time: formatDateTime(kioskState.kiosk.latestConnection, i18n) },
      );
    }

    return isEmpty(latestConnection) ? defaultMessage : `${defaultMessage} ${latestConnectionMessage}`;
  };

  if (!isEmpty(kioskState?.error)) {
    const connectionError = kioskState.connectionOk ? null : getConnectionErrorMessage();
    const backendError = get(kioskState.error, 'response.data.message');
    const networkError = get(kioskState.error, 'response.message');

    return (<>
      <Modal
        title={t('heartbeat.title')}
        visible={confirmModalOpen}
        centered={true}
        width="700px"
        footer={[
          <Button key="close" type="primary" onClick={() => {
            setConfirmModalOpen(false);
          }}>
            {t('close')}
          </Button>,
        ]}
        onCancel={() => {
          setConfirmModalOpen(false);
        }}
      >
        {connectionError || backendError || networkError || t('error.generic')}
      </Modal>
    </>);
  }
  return null;
};

export default ErrorKioskModal;
